// extracted by mini-css-extract-plugin
export default {"select":"AuctionListMenu_select__B5aAO","select-dropdown":"AuctionListMenu_select-dropdown__KR9Gg"};